import { PackageInfoRepository} from "@app/@core/repositories/package-info.repository";
import {LeisureShopRepository, ShopOption} from "@app/@core/repositories/leisure-shop.repository";
import {createState, select, Store, withProps} from "@ngneat/elf";
import {deleteEntities, selectAll, upsertEntities, withEntities} from "@ngneat/elf-entities";
import {PackageModel} from "@app/@core/domain/package.model";

import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {environment} from "@env/environment";
import {localStorageStrategy, persistState} from "@ngneat/elf-persist-state";
import {groupBy} from "lodash-es";
import {SelectItemGroup} from "primeng/api";
import orderBy from "lodash-es/orderBy";
import {PackageInfoModel} from "@app/models/package-info";
import PackageStatus = PackageModel.PackageStatus;


export interface LeisureShopState {
    options?: ShopOption[];
}


const {state, config} = createState(
    withEntities<PackageModel.PackageInfo>(),
    withProps<LeisureShopState>({
        options: []
    })
);

const store = new Store({name: 'ShopStore', state, config});
const getState = () => store.getValue();

const updateState = (newState: Partial<LeisureShopState>) => {
    store.update(s => ({...s, ...newState}));
};

@Injectable({
    providedIn: 'root'
})
export class LeisureShopService {


    fetchAllName(): Observable<ShopOption[]> {
        return this.leisureShopRepository.fetchNames().pipe(
            tap(options => updateState({options}))
        );
    }

    groupedOptions$ = store.pipe(select((({options}) => {
        const groupByStatus = groupBy(options, 'status');
        const sig: SelectItemGroup[] = [
            {label: 'OPEN', items: orderBy(groupByStatus.OPEN, 'name')},
            {label: 'HIDE', items: orderBy(groupByStatus.HIDE, 'name')},
            {label: 'CLOSE', items: orderBy(groupByStatus.CLOSE, 'name')},
        ];
        return sig;

    })));
    selectShopOptions$ = store.pipe(
        select(({options}) => {
            return options.map(option => ({
                label: option.label,
                value: option.value
            }));
        })
    );
    groupedOptionsNotRequire$ = store.pipe(select((({options}) => {
        const groupByStatus = groupBy(options, 'status');
        const sig: SelectItemGroup[] = [
            {
                label: 'OPEN',
                items: [{label: '- Not Select -', value: undefined}, ...orderBy(groupByStatus.OPEN, 'name')]
            },
            {label: 'HIDE', items: orderBy(groupByStatus.HIDE, 'name')},
            {label: 'CLOSE', items: orderBy(groupByStatus.CLOSE, 'name')},
        ];
        return sig;
    })));

    shop$ = store.pipe(selectAll());

    constructor(private repository: PackageInfoRepository,
                private leisureShopRepository: LeisureShopRepository,) {
        if (environment.cache?.shop) {
            persistState(store, {
                key: 'shop',
                storage: localStorageStrategy,
            });
        }
    }

    getName(packageId: string) {
        const p = getState().options.find(c => c.value === packageId);
        return p
            ? p.status === 'OPEN' ? p.label : `${p.label}[${p.status}]`
            : packageId;
    }

    hasLoaded() {
        return getState().options.length > 0;
    }


    updateShop(packages: PackageInfoModel.PackageInfo) {
        store.update(upsertEntities(packages));
    }

    delete(id: string) {
        store.update(deleteEntities(id));
    }
}
